import {connect} from "react-redux";
import * as deliveryGroupActions from "../actions/deliveryGroupsActions";
import * as messengersActions from "../actions/messengersActions";
import SentRouteDialog from "../../Components/Map/DeliveryGroupsMap/SentRouteDialog/SentRouteDialog";
import * as deliveryGroupsActions from "../actions/deliveryGroupsActions";
import * as logActions from "../actions/logActions";

const mapStateToProps = (store) => {
    return {
        readyOrders: store.ordersReducer.deliveryOrders.filter(order => order.status === "READY" && order.location),
        lockedDeliveryGroups: store.deliveryGroupsReducer.lockedDeliveryGroups,
        isAutopilot: store.businessReducer.business.isAutopilot
    }
};

const mapDispatchToProps = {
    cancelDeliveryGroup: deliveryGroupActions.cancelDeliveryGroupAction,
    updateMessengerAvailability: messengersActions.updateMessengerAvailabilityAction,
    finishDeliveryGroup: deliveryGroupActions.finishDeliveryGroupAction,
    editDeliveryGroup: deliveryGroupActions.editDeliveryGroupAction,
    cancelDeliveryGroupOrders: deliveryGroupActions.cancelDeliveryGroupOrdersAction,
    removeOrdersFromLockedGroup: deliveryGroupsActions.removeOrdersFromLockedGroup,
    logInfo: logActions.logInfoAction
};

const SentRouteDialogContainer = connect(mapStateToProps, mapDispatchToProps)(SentRouteDialog);

export default SentRouteDialogContainer;